import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { newsLettersApi } from '../api/newsLettersApi';

export enum DateRange {
  All,
  Last30Days = 30,
  Last90Days = 90,
  Last365Days = 365,
}

type InitialState = {
  dateRange: DateRange;
  searchTerm: string;
  showOnlyUnreadNotifications: boolean;
  totalCount: number;
  unreadIds: string[];
};

const initialState: InitialState = {
  dateRange: DateRange.All,
  searchTerm: '',
  showOnlyUnreadNotifications: false,
  totalCount: 0,
  unreadIds: [],
};

export const newsLettersSlice = createSlice({
  name: 'newsletters',
  initialState,
  reducers: {
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setShowOnlyUnreadNotifications: (state, action: PayloadAction<boolean>) => {
      state.showOnlyUnreadNotifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      newsLettersApi.endpoints.getNewsletters.matchFulfilled,
      (state, { payload }) => {
        const unreadNotificationsIds =
          payload.Data?.filter((notification) => !notification.IsRead).map(
            (notification) => notification.Id
          ) ?? [];
        const totalCount = payload.Paging?.TotalCount ?? 0;

        state.totalCount = totalCount;
        state.unreadIds = unreadNotificationsIds;
      }
    );
    builder.addMatcher(
      newsLettersApi.endpoints.getNewsletters.matchRejected,
      (state) => {
        state.totalCount = 0;
        state.unreadIds = [];
      }
    );
  },
});

export const { setDateRange, setSearchTerm, setShowOnlyUnreadNotifications } =
  newsLettersSlice.actions;
